var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding no-margin"},[(_vm.route==`/provider/employers`)?_c('Table'):_vm._e(),(_vm.route==`/provider/employers/add-new`)?_c('AddNewForm'):_vm._e(),(_vm.route==`/provider/employers/employer`)?_c('SingleForm'):_vm._e(),(_vm.route==`/provider/employers/invite-employer`)?_c('InviteForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }